import template from './template.html';
import visibilityEvents from '../../mixins/visibilityEvents';

export default {
    name: 'wordpressImage',
    template: template,
    mixins: [ visibilityEvents ],

    data() {
        return {
            count: 0,
        };
    },

    props: {
        image: Object,
        noCrop: Boolean,
    },

    watch: {
        in_view(val) {
            if (val) {
                this.count = 1;
            }
        }
    },

    computed: {
        inView() {
            return this.count >= 1;
        }
    },

};